import React, { useEffect, useState } from "react";
import GuideSection from "../../components/guide/GuideSection";
import { domiciliationGuide } from "../../components/guide/guideContent";
import { formatPrice } from "../../utils/formatPrice";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import pricing from "../../assets/data/pricing.json";
import {
  updateAdminRequest,
  updateBusinessRequest,
  updateDomiciliationRequest,
  updateGrhRequest,
  updateJuridiqueRequest,
  updateManagementRequest,
  updateSalesRequest,
} from "../../redux/actions/RequestActions";
import { addToServiceList } from "../../redux/actions/ServiceListActions";
import serviceCode from "../../assets/data/serviceCode.json";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";
import { Col, Image, Row } from "react-bootstrap";

function EditDomiciliation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const [selectedPlan, setSelectedPlan] = useState("mensuel");
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const { user } = useSelector((state) => state.authUser);
  const {
    businessCreationRequest,
    domiciliationRequest,
    managementRequest,
    juridiqueRequest,
    adminRequest,
    grhRequest,
    salesRequest,
  } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);
  const servicesList = useSelector((state) => state.serviceList.services);

  console.log(selectedPlan);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleButtonClick = async () => {
    setSubmitting(true);

    let updatedServices = [...servicesList];

    // Vérifie si un élément avec le même code existe déjà
    const existingIndex = updatedServices.findIndex(
      (service) => service.code === serviceCode.domiciliation,
    );

    const newService = {
      code: serviceCode.domiciliation,
      billing: selectedPlan === "annuel" ? "yearly" : "monthly",
    };

    if (existingIndex !== -1) {
      // Remplace l'élément existant
      updatedServices[existingIndex] = newService;
    } else {
      // Sinon, ajoute le nouvel élément
      updatedServices.push(newService);
    }

    if (cart.from === "creation") {
      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "domiciliation") {
      await dispatch(
        updateDomiciliationRequest(
          user.token,
          domiciliationRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "management") {
      await dispatch(
        updateManagementRequest(
          user.token,
          managementRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "admin") {
      await dispatch(
        updateAdminRequest(
          user.token,
          adminRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "juridique") {
      await dispatch(
        updateJuridiqueRequest(
          user.token,
          juridiqueRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "grh") {
      await dispatch(
        updateGrhRequest(
          user.token,
          grhRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "sales") {
      await dispatch(
        updateSalesRequest(
          user.token,
          salesRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    }
  };

  const handleCallback = async ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        addToCart({
          domiciliation: {
            periodicity: selectedPlan,
            amount:
              selectedPlan === "annuel"
                ? pricing.domiciliation.annuel
                : pricing.domiciliation.mensuel,
          },
        }),
      );

      await dispatch(
        addToServiceList({
          code: serviceCode.domiciliation,
          billing: selectedPlan === "annuel" ? "yearly" : "monthly",
        }),
      );
      navigate(-1, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleSkipClick = () => {
    navigate(-1, { replace: true });
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <>
        {cart.from === "domiciliation" ? (
          <div
            className="container mt-4 mb-2 text-center"
            style={{ maxWidth: "800px" }}
          >
            <h4 className="text-center mb-4">
              Choisissez votre abonnement pour{" "}
              <span style={{ color: "#FF5500" }}>domicilier</span> votre{" "}
              {cart?.businessType} chez Platform98.
            </h4>
          </div>
        ) : (
          <div
            className="container mt-4 mb-2 text-center"
            style={{ maxWidth: "800px" }}
          >
            <h4 className="text-2xl font-semibold">
              Souhaitez-vous{" "}
              <span style={{ color: "#FF5500" }}>domicilier</span> votre{" "}
              {cart?.businessType} chez Platform98 ?
            </h4>
          </div>
        )}

        <div className="container mt-2 text-center">
          <p className="text-lg mb-6">
            Découvrez les services de domiciliation proposés par Platform98 pour
            accompagner le développement de votre entreprise.
          </p>
        </div>

        <div className="container justify-items-center mt-4">
          <Row className="justify-content-center text-center">
            <Col md={2} className="mb-3">
              <Image
                src="/images/domiciliation/administrative_and_tax_address.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />

              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Adresse administrative & fiscale
              </div>
            </Col>
            <Col md={2} className="mb-3">
              <Image
                src="/images/domiciliation/mail_reception_and_sorting.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />

              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Réception et tri de courrier
              </div>
            </Col>
            <Col md={2} className="mb-3">
              <Image
                src="/images/domiciliation/mail_scanning.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Scan et transfert de courrier
              </div>
            </Col>
            <Col md={2} className="mb-3">
              <Image
                src="/images/domiciliation/telephone_reception.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Accueil téléphonique personnalisé
              </div>
            </Col>

            <Col md={2} className="mb-3">
              <Image
                src="/images/domiciliation/tax_localization.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Localisation fiscale
              </div>
            </Col>
          </Row>
        </div>

        <div className="container mt-2 text-center">
          <h5 className="mb-3">Choisissez votre abonnement</h5>
          <div className="d-flex justify-content-center gap-4">
            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="mensuel"
                checked={selectedPlan === "mensuel"}
                onChange={() => setSelectedPlan("mensuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.domiciliation.mensuel)} / mois (abonnement
                mensuel)
              </span>
            </label>

            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="annuel"
                checked={selectedPlan === "annuel"}
                onChange={() => setSelectedPlan("annuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.domiciliation.annuel)} x 12 / an
              </span>
            </label>
          </div>
        </div>

        <div className="container text-center mt-3">
          <button
            className="btn"
            style={{
              backgroundColor: "#051259",
              borderRadius: "50px",
              color: "#fff",
              padding: "10px",
              fontWeight: "bold",
              display: "inline-flex",
              alignItems: "center",
            }}
            onClick={handleButtonClick}
          >
            {cart.from !== "domiciliation" ? "Obtenir ce service" : "Continuer"}
            <FaArrowRight style={{ marginLeft: "8px" }} />
          </button>

          {cart.from !== "domiciliation" && (
            <div className="container text-center mt-3">
              <span
                onClick={handleSkipClick}
                style={{ color: "#3392FF", cursor: "pointer" }}
              >
                Retour
              </span>
            </div>
          )}
        </div>

        <GuideSection {...domiciliationGuide} />
      </>
    </div>
  );
}

export default EditDomiciliation;
